import { DASH_META_ROOT, getAuthDashMetaCsrfToken } from '@revelio/auth';

import type { DataBuilderPayload } from './data-builder-api.types';

async function fetchJson<T>(
  input: RequestInfo | URL,
  init?: RequestInit
): Promise<T> {
  const csrfToken = getAuthDashMetaCsrfToken();

  const response = await fetch(input, {
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      'x-surf-token-dash-meta': csrfToken ?? '',
      ...(init?.headers || {}),
    },
    ...init,
  });

  if (!response.ok) {
    const message = await response.text();
    const error: Error & { status?: number } = new Error(
      message || 'Unknown error'
    );
    error.status = response.status;
    throw error;
  }

  if (response.status === 204) {
    return undefined as T;
  }

  return await response.json();
}

export type SavedDataBuilderDataset = {
  _id: string;
  userId: string;
  name: string;
  payload: DataBuilderPayload;
  createdAt: string;
  updatedAt: string;
};

export const listDataBuilderDatasets = (): Promise<SavedDataBuilderDataset[]> =>
  fetchJson<SavedDataBuilderDataset[]>(
    `${DASH_META_ROOT}/api/data-builder/datasets`,
    { method: 'GET' }
  );

export const saveDataBuilderDataset = (input: {
  name: string;
  payload: DataBuilderPayload;
}): Promise<SavedDataBuilderDataset> =>
  fetchJson<SavedDataBuilderDataset>(
    `${DASH_META_ROOT}/api/data-builder/datasets`,
    {
      method: 'POST',
      body: JSON.stringify(input),
    }
  );

export const updateDataBuilderDataset = (input: {
  id: string;
  name: string;
  payload: DataBuilderPayload;
}): Promise<SavedDataBuilderDataset> =>
  fetchJson<SavedDataBuilderDataset>(
    `${DASH_META_ROOT}/api/data-builder/datasets/${input.id}`,
    {
      method: 'PUT',
      body: JSON.stringify({
        name: input.name,
        payload: input.payload,
      }),
    }
  );

export const deleteDataBuilderDataset = (id: string): Promise<void> =>
  fetchJson<void>(`${DASH_META_ROOT}/api/data-builder/datasets/${id}`, {
    method: 'DELETE',
  });
